import Dropdown from 'bootstrap/js/dist/dropdown'
import Collapse from 'bootstrap/js/dist/collapse'

	/**
	 * Collapse
	 */
		const siteCollapses = document.querySelectorAll('.collapse')

		if (siteCollapses.length > 0) {
			siteCollapses.forEach(e => {
				e.addEventListener('show.bs.collapse', event => {
					e.parentElement.classList.add('is--open')
				})

				e.addEventListener('shown.bs.collapse', event => {
					e.parentElement.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
						inline: 'nearest'
					})
				})

				e.addEventListener('hide.bs.collapse', event => {
					e.parentElement.classList.remove('is--open')
				})
			})
		}
